<template lang="pug" src="./systemNotifications.pug"></template>
<style lang="scss" src="./systemNotifications.scss" scoped></style>

<script>
import { mapGetters, mapState } from 'vuex'
import scroll from '@/utils/scroll'
import { processNotification, notificationIcon } from '@/utils/helpers'

export default {
    data: () => ({
        filters: {
            types: [],
            fromDate: null,
            toDate: null
        }
    }),
    computed: {
        ...mapGetters(['type']),
        ...mapState({
            notificationsHistory: state => state.systemNotifications.notificationsHistory,
            pagination: state => state.systemNotifications.pagination,
            appliedFilters: state => state.systemNotifications.filters,
            isLoaded: state => state.systemNotifications.isLoaded,
            user: state => state.app.user
        }),
        leaderTypeSelects: function() {
            const typeSelects = '$vuetify.pages.SystemNotifications.autocomplete'

            return ['newBusiness', 'emailConfirmed'].map(it => ({
                text: this.$vuetify.t(`${typeSelects}.${it}`),
                value: it
            }))
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getNotificationsByPage(this.pagination.page)
    },
    mounted: function() {
        this.$store.dispatch('systemNotifications/readNotifications')
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('systemNotifications/SET_PAGINATION', { page: 1, length: null })
        this.$store.commit('systemNotifications/RESET_NOTIFICATIONS')
        next()
    },
    methods: {
        reset() {
            this.filters = Object.assign({}, {
                types: [],
                fromDate: null,
                toDate: null
            })
            this.$store.commit('systemNotifications/RESET_NOTIFICATIONS')
            this.getNotificationsByPage()
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getNotificationsByPage(page, true)
            }
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        translateNotification: function(notification) {
            const userData = processNotification(notification)
            return this.$vuetify.t(`$vuetify.pages.SystemNotifications.${notification.type}`)
                .replace('{content}', userData)
                .replace('{currency}', notification.text && notification.text.sum / 100)
        },
        submit() {
            this.$store.commit('systemNotifications/SET_FILTERS', Object.assign({}, this.filters))
            this.getNotificationsByPage()
        },
        getNotificationsByPage(page = 1, isScrollEnable = false) {
            this.$store.dispatch('systemNotifications/getNotificationsHistory', {
                page,
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.notifications)
                }
            })
        },
        notificationIcon
    }
}
</script>

